<template>
  <div class="threeSolidHome">
    <div class="cqmap">
      <cqmap />
    </div>

    <div class="car">
      <div class="itemcard" v-for="itme in houselist" :key="itme.id">
        <span class="itemcardtitle">{{ itme.title }}</span>
        <span class="itemcardnum">{{ itme.num }}</span>
      </div>
    </div>

    <div class="home-content">
      <housingLeft></housingLeft>
      <housingRight></housingRight>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, reactive, toRefs, onMounted } from "vue";
import { useRouter } from "vue-router";
import housingLeft from "./components/housingLeft";
import housingRight from "./components/housingRight";
import {
  houseCount,
  houseLive,
  houseProperty,
  houseUsage,
} from "@/api/dataAnalysis/housingAnalysis.js";
import cqmap from "../map.vue";
export default defineComponent({
  name: "",
  components: {
    housingLeft,
    housingRight,
    cqmap,
  },
  props: {
    cpn: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const list = reactive([
      { id: 0, title: "人口分析", conponent: "housingAnalysis" },
      { id: 1, title: "房屋分析", conponent: "populationAnalysis" },
      { id: 2, title: "单位分析", conponent: "unitOfAnalysis" },
      { id: 3, title: "事件分析", conponent: "eventAnalysis" },
      { id: 4, title: "告警分析", conponent: "warningAnalysis" },
    ]);
    const houselist = reactive([
      { id: 0, title: "房屋总数", num: 0 },
      { id: 1, title: "自用总数", num: 0 },
      { id: 2, title: "租用总数", num: 0 },
      { id: 3, title: "空置总数", num: 0 },
      { id: 4, title: "住宅总数", num: 0 },
      { id: 5, title: "国有房产总数", num: 0 },
      { id: 6, title: "集体所有房产总数", num: 0 },
      { id: 7, title: "私有房产总数", num: 0 },
    ]);
    const options = reactive([
      // {
      //   value: "选项1",
      //   label: "黄金糕"
      // },
      // {
      //   value: "选项2",
      //   label: "双皮奶"
      // },
      // {
      //   value: "选项3",
      //   label: "蚵仔煎"
      // },
      // {
      //   value: "选项4",
      //   label: "龙须面"
      // },
      // {
      //   value: "选项5",
      //   label: "北京烤鸭"
      // }
    ]);
    const data = reactive({
      value: "",
      regionId: 0,
    });
    const refData = toRefs(data);
    data.regionId = JSON.parse(localStorage.getItem("regionId"));
    // 获取房屋总数
    const houseCountlist = async () => {
      const res = await houseCount(data.regionId);
      houselist.forEach((v) => {
        if (v.id === 0) {
          v.num = res.data.value;
        }
        // if (v.id === 6) {
        //   v.num = res.data.value;
        // }
      });
    };
    // 获取自用和租用数量和空置
    const houseLivetlist = async () => {
      const res = await houseLive(data.regionId);
      houselist.forEach((v) => {
        if (v.id === 1) {
          res.data.forEach((j) => {
            if (j.id === 0) {
              v.num = j.value;
            }
          });
        }
        if (v.id === 2) {
          res.data.forEach((j) => {
            if (j.id === 1) {
              v.num = j.value;
            }
          });
        }
        if (v.id === 3) {
          res.data.forEach((j) => {
            if (j.id === 4) {
              v.num = j.value;
            }
          });
        }
      });
    };
    // 获取国有和私有
    const housePropertylist = async () => {
      const res = await houseProperty(data.regionId);
      houselist.forEach((v) => {
        if (v.id === 5) {
          res.data.forEach((j) => {
            if (j.id === 10) {
              v.num = j.value;
            }
          });
        }
        if (v.id === 7) {
          res.data.forEach((j) => {
            if (j.id === 30) {
              v.num = j.value;
            }
          });
        }
        if (v.id === 6) {
          res.data.forEach((j) => {
            if (j.id === 20) {
              v.num = j.value;
            }
          });
        }
      });
    };
    // 获取住宅
    const houseUsagelist = async () => {
      const res = await houseUsage(data.regionId);
      houselist.forEach((v) => {
        if (v.id === 4) {
          res.data.forEach((j) => {
            if (j.id == 10) {
              v.num = j.value;
            }
          });
        }
      });
    };
    onMounted(() => {
      houseCountlist();
      houseLivetlist();
      housePropertylist();
      houseUsagelist();
    });
    return {
      list,
      houselist,
      options,
      ...refData,
      // houseCountlist,
      // houseLivetlist,
      // housePropertylist,
      // houseUsagelist,
    };
  },
});
</script>
<style lang="scss" scoped>
.threeSolidHome {
  background: url("~@/assets/images/threeSolid/threebg.png");
  height: 100%;
  width: 100%;
  position: relative;
  .cqmap {
    position: relative;
    top: 0;
    left: 0;
    width: 500px;
    height: 500px;
  }
  .test-map {
    position: absolute;
    top: 2%;
    left: 0;
    right: 0;
    margin: auto;
    width: 100%;
    display: flex;
    justify-content: center;
    color: #fff;
    z-index: 10;
    button {
      border: none;
    }
  }
  .car {
    z-index: 3;
    width: 1050px;
    height: 210px;
    background-image: url("~@/assets/images/0303/box.png");
    background-repeat: no-repeat;
    position: absolute;
    bottom: -100px;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    box-sizing: border-box;
    padding: 10px 100px;
    .itemcard {
      margin-right: 15px;
      width: 165px;
      height: 70px;

      background-image: url("~@/assets/images/0303/cardbg.png");
      background-repeat: no-repeat;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      .itemcardtitle {
        color: #fff;
        font-size: 18px;
        font-weight: 700;
      }
      .itemcardnum {
        color: #23fffc;
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
  .selectarea {
    background-color: rgba(0, 0, 0, 0.3);
    background-repeat: no-repeat;
    position: absolute;
    bottom: 195px;
    left: 39%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 5;
    padding: 10px;
    box-sizing: border-box;
    ::v-deep .el-select {
      margin-right: 15px !important;
    }
    .selectareaitme {
      z-index: 5;
    }
    ::v-deep .el-input__inner {
      background-color: #065080 !important;
      outline: none !important;
      border: none !important;
      .el-range-separator {
        color: #fff !important;
      }
      input {
        background-color: #065080 !important;
        color: #fff !important;
      }
    }
  }
  .btn {
    position: relative;
    color: #fff;
    width: 145px;
    height: 50px;
    background-color: rgba(255, 255, 255, 0);
    background-image: url("~@/assets/images/0303/menu2.png");
    background-repeat: no-repeat;
    &.active {
      color: #fff;
      width: 145px;
      height: 50px;
      background-color: rgba(255, 255, 255, 0);
      background-image: url("~@/assets/images/0303/menu1.png");
      background-repeat: no-repeat;
    }
  }
  .cqmap {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 2;
  }
  .home-content {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;
    pointer-events: none;
    display: flex;

    .home-left {
      pointer-events: auto;
    }
  }
}
</style>
